var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    {
      staticStyle: { padding: "0 20px" },
      attrs: { xs6: _vm.userCanAddObjects }
    },
    [
      _vm.actionType !== "edit" && _vm.actionType !== "view"
        ? _c("div", { staticStyle: { height: "20px" } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "home-form-table-toolbar",
        { staticClass: "mt-2" },
        [
          _c("home-form-table-select-all-tool", {
            attrs: { disabled: !_vm.toolbarEnabled },
            on: { click: _vm.selectAll }
          }),
          _vm._v(" "),
          _c("home-form-table-select-invert-tool", {
            attrs: { disabled: !_vm.toolbarEnabled },
            on: { click: _vm.invertSelection }
          }),
          _vm._v(" "),
          _c("home-form-table-select-none-tool", {
            attrs: { disabled: !_vm.toolbarEnabled },
            on: { click: _vm.clearSelection }
          }),
          _vm._v(" "),
          _c("div", { staticStyle: { width: "100%" } }),
          _vm._v(" "),
          _c("home-form-table-remove-from-list-tool", {
            attrs: {
              disabled: !_vm.toolbarEnabled,
              tooltip: _vm.$t("RemoveFromList")
            },
            on: { click: _vm.removeAssetsFromReservation }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "multi-selection-table-container no-select scroll-fire-fox",
          staticStyle: {
            height: "fit-content",
            overflow: "scroll",
            "max-height": "90%"
          }
        },
        [
          _c(
            "table",
            {
              staticClass: "multi-selection-table",
              staticStyle: { position: "relative" },
              attrs: { id: "table" }
            },
            [
              _c("tr", { staticClass: "table-header" }, [
                _c("th", { staticClass: "object-index" }),
                _vm._v(" "),
                _c("th", [_vm._v(_vm._s(_vm.$tc("Layer", 1)))]),
                _vm._v(" "),
                _c("th", [_vm._v("ID")]),
                _vm._v(" "),
                _c("th", [_vm._v(_vm._s(_vm.$tc("Label", 1)))]),
                _vm._v(" "),
                _c("th", [_vm._v(_vm._s(_vm.$t("DroppedDate")))])
              ]),
              _vm._v(" "),
              _vm._l(_vm.assetReservationObjects, function(
                object,
                objectIndex
              ) {
                return _c(
                  "tr",
                  {
                    key: objectIndex,
                    staticClass: "table-body",
                    class: {
                      selected: _vm.selectedIndexes.includes(objectIndex)
                    },
                    style: {
                      pointerEvents: _vm.actionType === "view" ? "none" : "auto"
                    },
                    on: {
                      click: function($event) {
                        return _vm.select(objectIndex, $event)
                      }
                    }
                  },
                  [
                    _c("td", { staticClass: "object-index" }, [
                      _vm._v(_vm._s(objectIndex + 1))
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "input-disabled" }, [
                      _vm._v(_vm._s(_vm.getObjectLayer(object)))
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "input-disabled" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.getAssetReservationObjectID(object)) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "input-disabled" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.getAssetReservationObjectLabel(object)) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "input-disabled" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.getAssetReservationObjectDroppedDate(object)
                          ) +
                          "\n        "
                      )
                    ])
                  ]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm.assetReservationObjects.length === 0
            ? _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "14px",
                    "text-align": "center",
                    "margin-top": "5%"
                  }
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("NoAssetsWarning")) + "\n    "
                  )
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.dissociateObjectDialog.open,
          title: _vm.$t("Delete"),
          content:
            _vm.$t("DissociateAssetReservationObject") +
            "\n\n" +
            _vm.$t("ContinueConfirmation"),
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes")
        },
        on: {
          mainAction: _vm.closeDissociateObjectDialog,
          secondaryAction: _vm.dissociateObject
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a5ca2670", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ca2670","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/AssetReservationForm/AssetsTab/SelectedAssetReservationObjects.vue
// module id = null
// module chunks = 